const TRIAL_FUNNEL_KEY = 'lingochat_trial_funnel'

// Whether this browser has ever entered the trial funnel. The flag is sticky:
// once set it is never cleared, so come-back visitors who later arrive through
// the normal funnel are still served the trial sales page.
export function isTrialFunnel(): boolean {
  return localStorage.getItem(TRIAL_FUNNEL_KEY) === 'true'
}

export function markTrialFunnel(): void {
  localStorage.setItem(TRIAL_FUNNEL_KEY, 'true')
}
